/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { Link } from 'react-router-dom';
import { Container, Button, Form, Spinner } from 'react-bootstrap';
import axios from 'axios';

// project imports
import { getAdminUrl, getAdminHeaders } from 'shared/http/';
import { passwordreset } from 'shared/settings/apiconfig';
import Validators from 'shared/validators/';
// import toast from 'shared/toast';
import { ToasterMessage } from 'shared/toast/toast';

// style imports
import './ForgotPassword.scss';

/**
 * verify username to send verification link on forgot password
 * 
 * @return forgot password html code
 * 
**/

export class ForgotPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            form: {
                email: { value: '', error: '', validators: [Validators.required(), Validators.email()] }
            },
            valid: false,
            loading:false,
            status: { show: false, type: '', message: ''}
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

    }
    
    keyEnter = (event) => {
        if(event.key === 'Enter' && this.state.valid){
            this.handleSubmit()
        }
    }
    /* validation for input changes */
    handleChange = (event) => {
        let inputError = '';
        for (let validator of this.state.form[event.target.name].validators) {
            inputError = validator(event.target.value);
            if (inputError) break;
        }

        this.setState({
            ...this.state,
            valid: !inputError,
            form: {
                ...this.state.form,
                [event.target.name]: {
                    ...this.state.form[event.target.name],
                    value: event.target.value,
                    error: inputError
                }
            }
        }, () => {
            if (!inputError && !inputError.length) {
                this.setState({
                    ...this.state,
                    valid: true
                });
            }
        });
    }

    /* called when send password link button clicked */
    handleSubmit = async () => {
        this.setState({loading:true});
        await axios.post(getAdminUrl(passwordreset), JSON.stringify({ data: { email: this.state.form.email.value }}),getAdminHeaders())
            .then(response => {
                if(response.status  === 200){
                    this.setState({
                        loading:false,
                        status: { show: true, type: 'success', message: response.data['message']}
                    }, () => {
                        setTimeout( () => {
                            this.setState({
                                loading:false,
                                status: { show: false, tpye: '', message: ''}
                            }, () => this.props.history.push('/') );
                        }, 3000);
                    });
                    // toast.success(response.data['message']);
                    
                }
            })
            .catch(error => {
                this.setState({
                    loading:false,
                    status: { show: true, type: 'danger', message: error.response.data['message']}
                });
                // toast.error(error.response.data['message']);    
            });
    }

    render() {
        return (
            <div className="d-flex align-items-center justify-content-center forgot-password-page">
                <Container className="container-align">
                    <div>
                        <Link to="/">
                            <i className="fas fa-chevron-circle-left fa-lg"></i>
                            <span className="ml-2">Back</span>
                        </Link>
                        <div className="forgot-password-form">
                            <span className="color"><b>Forgot password</b></span>
                            <Form className="form" onSubmit={(event) => event.preventDefault()}>
                                <div>
                                    <div className="float-control">
                                        <div className="text">
                                            {
                                                this.state.form.email.error && this.state.form.email.error.length ? <small className="error">{this.state.form.email.error}</small> : null
                                            }
                                        </div>
                                        <Form.Control autoFocus id="email" name="email" type="email" className="border-radius" onKeyDown={(event) => this.keyEnter(event)}  onChange={(event) => this.handleChange(event)} placeholder=" " />
                                        <label htmlFor="email">Email</label>
                                    </div>
                                </div>
                            </Form>
                            <div className="mt-4">
                                {
                                    this.state.status.show ? 
                                        <ToasterMessage type={this.state.status.type} message={this.state.status.message} className="alert-handle mt-2"></ToasterMessage>
                                        : null
                                }
                            </div>    
                            <Button variant="secondary" type="button" style={{ cursor: this.state.valid && !this.state.loading ? '' : 'not-allowed', marginTop: "3%" }} disabled={this.state.valid  && !this.state.loading && this.state.status.type !== 'success' ? false : true} onClick={() => this.handleSubmit()}>Send Password Link {' '} {this.state.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}</Button>
                        </div>
                    </div>
                </Container>
            </div>
        );
    }
}